<template>
  <v-col 
    cols="12" 
    sm="6" 
    md="4"
    class="mb-4"
  >
    <v-card 
      class="well-card elevation-3"
      :class="`category-${well.category.name.toLowerCase().replace(/\s+/g, '-')}`"
      hover
      @click="showDetail"
    >
      <v-card-text class="pa-3">
        <!-- Header com categoria destacada -->
        <div class="category-header mb-2" :style="{ backgroundColor: well.category.color + '15', borderLeft: '3px solid ' + well.category.color }">
          <div class="d-flex align-center pa-2">
            <v-avatar 
              :color="well.category.color" 
              size="36"
              class="mr-2 elevation-2"
            >
              <v-icon color="white" size="18">{{ well.category.icon }}</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <h3 class="text-subtitle-1 font-weight-bold mb-0" :style="{ color: well.category.color }">
                {{ well.category.name }}
              </h3>
              <div class="d-flex align-center">
                <span class="text-caption well-id">#{{ well.id }}</span>
                <span class="text-caption well-code ml-1" v-if="well.code">• {{ well.code }}</span>
              </div>
            </div>
          </div>
        </div>


        <!-- Endereço completo -->
        <div class="address-section mb-2" v-if="well.address">
          <div class="d-flex align-start">
            <v-icon color="#9E9E9E" size="16" class="mr-2 mt-1">location_on</v-icon>
            <div class="address-content">
              <!-- Endereço e número destacados -->
              <div class="address-main mb-1">
                <span class="text-body-2 font-weight-bold address-street">
                  {{ well.address.address }}
                </span>
                <span class="text-body-2 font-weight-bold address-number ml-1" v-if="well.address.number">
                  , {{ well.address.number }}
                </span>
              </div>
              <!-- Resto do endereço em fonte menor -->
              <div class="address-details">
                <span class="text-caption address-detail" v-if="well.address.district">
                  {{ well.address.district }}
                </span>
                <span class="text-caption address-detail ml-1" v-if="well.address.city">
                  • {{ well.address.city.name }}
                </span>
                <span class="text-caption address-detail ml-1" v-if="well.address.city && well.address.city.state">
                  - {{ well.address.city.state.code }}
                </span>
                <span class="text-caption address-detail ml-1" v-if="well.address.zip_code">
                  • {{ well.address.zip_code }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Status do poço -->
        <div class="status-section mb-2" v-if="well.status">
          <div class="d-flex align-center">
            <v-icon :color="well.status.color" size="14" class="mr-1">{{ well.status.icon }}</v-icon>
            <span class="text-caption status-text" :style="{ color: well.status.color }">
              Status: {{ well.status.name }}
            </span>
          </div>
        </div>

        <!-- Botão de detalhes -->
        <div class="text-center">
          <v-btn 
            :color="well.category.color" 
            outlined 
            small
            class="details-btn"
            @click.stop="showDetail"
          >
            <v-icon left small>visibility</v-icon>
            Ver Detalhes
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "WellCard",
  props: {
    well: {
      type: Object,
      required: true
    }
  },
  methods: {
    showDetail() {
      this.$emit('show-detail', this.well);
    }
  }
};
</script>

<style scoped>
/* Estilos para os cards de poços */
.well-card {
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.well-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15) !important;
  border-color: rgba(0, 0, 0, 0.1);
}

/* Header da categoria */
.category-header {
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

.well-card:hover .category-header {
  transform: scale(1.01);
}

/* Avatar da categoria */
.v-avatar {
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.well-card:hover .v-avatar {
  transform: scale(1.05) rotate(3deg);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
}

/* Título da categoria */
.text-subtitle-1 {
  transition: all 0.3s ease;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.well-card:hover .text-subtitle-1 {
  transform: translateX(1px);
}

/* ID e código do poço */
.well-id {
  color: #666;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.05);
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 0.7rem;
}

.well-code {
  color: #999;
  font-size: 0.7rem;
}

/* Seção de informações do poço */
.well-info-section {
  transition: all 0.3s ease;
}

.well-info-card {
  border-radius: 8px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.well-info-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.well-card:hover .well-info-card::before {
  transform: translateX(100%);
}

.well-label {
  color: #666;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.7rem;
}

.well-details {
  transition: all 0.3s ease;
}

.well-detail {
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
  font-size: 0.8rem !important;
}

.well-card:hover .well-detail {
  transform: scale(1.05);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Seção de endereço */
.address-section {
  background: rgba(158, 158, 158, 0.05);
  border-radius: 8px;
  padding: 10px;
  border-left: 3px solid #9E9E9E;
  transition: all 0.3s ease;
}

.well-card:hover .address-section {
  background: rgba(158, 158, 158, 0.08);
  border-left-color: #757575;
  transform: translateX(2px);
}

.address-content {
  flex-grow: 1;
}

.address-main {
  line-height: 1.2;
}

.address-street {
  color: #333;
  font-size: 0.9rem !important;
  transition: all 0.3s ease;
}

.address-number {
  color: #1976d2;
  font-size: 0.9rem !important;
  transition: all 0.3s ease;
}

.well-card:hover .address-street {
  color: #000;
}

.well-card:hover .address-number {
  color: #1565c0;
  transform: scale(1.02);
}

.address-details {
  line-height: 1.3;
  margin-top: 2px;
}

.address-detail {
  color: #666;
  font-size: 0.7rem;
  transition: all 0.3s ease;
}

.well-card:hover .address-detail {
  color: #555;
}

/* Seção de status */
.status-section {
  background: rgba(76, 175, 80, 0.05);
  border-radius: 6px;
  padding: 6px;
  border-left: 2px solid #4CAF50;
}

.status-text {
  font-weight: 500;
  font-size: 0.7rem;
  text-transform: capitalize;
}

/* Botão de detalhes */
.details-btn {
  border-radius: 20px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  position: relative;
  overflow: hidden;
}

.details-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.details-btn:hover::before {
  left: 100%;
}

.details-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
}

/* Responsividade */
@media (max-width: 600px) {
  .well-card {
    margin-bottom: 12px;
  }
  
  .category-header,
  .well-info-card,
  .address-section,
  .status-section {
    padding: 8px !important;
  }
  
  .address-section {
    padding: 8px !important;
  }
  
  .address-street,
  .address-number {
    font-size: 0.8rem !important;
  }
  
  .address-detail {
    font-size: 0.65rem !important;
  }
  
  .text-subtitle-1 {
    font-size: 0.9rem !important;
  }
  
  .well-detail {
    font-size: 0.7rem !important;
  }
  
  .well-info-card {
    min-height: 44px !important;
  }
}

/* Animações de entrada */
.well-card {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Delay escalonado para os cards */
.well-card:nth-child(1) { animation-delay: 0.1s; }
.well-card:nth-child(2) { animation-delay: 0.2s; }
.well-card:nth-child(3) { animation-delay: 0.3s; }
.well-card:nth-child(4) { animation-delay: 0.4s; }
.well-card:nth-child(5) { animation-delay: 0.5s; }
.well-card:nth-child(6) { animation-delay: 0.6s; }
</style>
